(() => {
  const PRODUCT_PATH = '/products/cry-wolf-indoor-pool-table-black-square-leg';
  if (window.location.pathname !== PRODUCT_PATH) return;

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const COMPLETE_LABEL = 'Cloth Colour - Included in Price';

  function updateClothLabel() {
    const fields = document.querySelectorAll('.gpo-element');

    fields.forEach((field) => {
      const candidates = field.querySelectorAll('label, legend, .gpo-label, [class*="gpo-label"]');

      candidates.forEach((label) => {
        const current = normalize(label.textContent);

        if (/^Cloth Colour - Included in Price$/i.test(current)) return;
        if (!/^Cloth Colour$/i.test(current)) return;

        const directTextNode = Array.from(label.childNodes).find((node) =>
          node.nodeType === Node.TEXT_NODE && /^Cloth Colour$/i.test(normalize(node.nodeValue))
        );

        if (directTextNode) {
          directTextNode.nodeValue = COMPLETE_LABEL;
        } else {
          label.textContent = COMPLETE_LABEL;
        }
      });
    });
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      updateClothLabel();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
